"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var colors_1 = require("../../theme/colors");
var spinner_1 = require("../spinner");
function ToggleDetailsButton(_a) {
    var showing = _a.showing, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, onClick = _a.onClick;
    return (react_1.default.createElement(StyledExpandButton, { type: "button", onClick: onClick, loading: isLoading },
        showing ? 'Hide details' : 'Show details',
        ' ',
        !isLoading && (react_1.default.createElement(StyledButtonIconWrapper, { rotate: showing ? 0 : 180 },
            react_1.default.createElement(Icon, null))),
        isLoading && (react_1.default.createElement(LoadingSpinnerWrapper, null,
            react_1.default.createElement(spinner_1.CircleSpinnerInline, null)))));
}
exports.default = ToggleDetailsButton;
var LoadingSpinnerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  margin-left: 4px;\n"], ["\n  margin-left: 4px;\n"])));
function Icon() {
    return (react_1.default.createElement("svg", { width: "10", height: "6", viewBox: "0 0 10 6", fill: "none" },
        react_1.default.createElement("path", { d: "M0 5.5L5 0.5L10 5.5H0Z", fill: "currentColor" })));
}
var StyledExpandButton = styled_components_1.default.button(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  height: 24px;\n  outline: 0;\n  border: 0;\n  background: none;\n  font-size: 14px;\n  box-sizing: border-box;\n  color: ", ";\n  padding: 2px 8px;\n  margin-left: -8px;\n  border-radius: 4px;\n  display: inline-flex;\n  line-height: 14px;\n  align-items: center;\n  font-family: ", ";\n\n  ", "\n"], ["\n  height: 24px;\n  outline: 0;\n  border: 0;\n  background: none;\n  font-size: 14px;\n  box-sizing: border-box;\n  color: ", ";\n  padding: 2px 8px;\n  margin-left: -8px;\n  border-radius: 4px;\n  display: inline-flex;\n  line-height: 14px;\n  align-items: center;\n  font-family: ", ";\n\n  ", "\n"])), colors_1.colors.steel[400], theme_1.fontFamilies.body, function (_a) {
    var loading = _a.loading;
    return !loading
        ? "&:hover {\n      background-color: ".concat(colors_1.colors.steel[100], ";\n    }")
        : "pointer-events: none;";
});
var StyledButtonIconWrapper = styled_components_1.default.div(function (_a) {
    var rotate = _a.rotate;
    return "\n  margin-left: 8px;\n  outline: 0;\n  display: flex;\n  align-items: center;\n  transform: rotate(".concat(rotate, "deg)\n  ");
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map